import type {
  UserCouponResource,
  CouponResource,
} from '@/features/billing/api/resources/coupon'
import type { Coupon, CouponOffType } from '@/features/billing/coupons/Coupon'

export function mapUserCouponResourceToCoupon(
  resource: UserCouponResource,
): Coupon {
  return mapCouponResourceToCoupon(resource.coupon)
}

export function mapCouponResourceToCoupon(resource: CouponResource): Coupon {
  return {
    id: resource.id,
    name: resource.friendly_name || '',
    description: resource.description || '',
    code: resource.code,
    offType: mapOffTypeResourceToOffType(resource.off_type),
    isExpired: isExpired(resource.date_expires),
  }
}

function mapOffTypeResourceToOffType(
  offType: UserCouponResource['coupon']['off_type'],
): CouponOffType {
  switch (offType.type) {
    case 'AMOUNT_OFF':
      return {
        type: 'Amount',
        amount: offType.amount_off,
      }
    case 'PERCENT_OFF':
      return {
        type: 'Percent',
        percent: offType.percent_off,
      }
    default:
      return {
        type: 'Amount',
        amount: 0,
      }
  }
}

/**
 * Whether the coupon is expired.
 */
function isExpired(dateExpires?: string): boolean {
  if (!dateExpires) {
    return false
  }

  return new Date(dateExpires) < new Date()
}
